module.exports = __webpack_public_path__ + "packs/media/images/image_hike-7b73ce35f04e4432d11651462c6d62de.png";